import i18n from "i18next"
import { initReactI18next } from "react-i18next"

const navigationDetails = localStorage.getItem("persist:navigationDetails")
const savedLanguage = navigationDetails
  ? JSON.parse(JSON.parse(navigationDetails).language)
  : null

const resources = {
  mx: {
    translation: require("../locales/mx/translation.json"),
  },
  es: {
    translation: require("../locales/es/translation.json"),
  },
  en: {
    translation: require("../locales/en/translation.json"),
  },
}

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "mx",
    lng: savedLanguage || "mx",
    // detection: {
    //   order: ["navigator"],
    // },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
